import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url || '';
  // Do not attach auth header for local asset requests (i18n, images, etc.)
  // or for Console API (mc-sit.myservy.com) calls — those use session auth, not Bearer tokens.
  if (
    url.startsWith('/assets') ||
    url.startsWith('assets') ||
    url.includes('/assets/') ||
    url.startsWith(environment.apimyservy)
  ) {
    console.log(
      '[i18n][interceptor] skipping auth header for asset request:',
      req.url,
    );
    return next(req);
  }

  const token = localStorage.getItem('auth_token');
  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log('[AuthInterceptor] Added Authorization header:', {
      url: req.url,
      token,
    });
    return next(authReq);
  }
  return next(req);
};
